export default __webpack_public_path__ + "static/media/mitigation-stair-framing-overview.c0a20ded.jpg";